import useHostGlobals from 'appHost/Globals';

const useGlobals = () => {
  const hostGlobals = useHostGlobals();

  return {
    user: hostGlobals?.user,
    traffic: hostGlobals?.traffic,
    dispatchToGlobal: hostGlobals?.dispatchToGlobal,
    amplitude: hostGlobals?.amplitude,
  };
};

export default useGlobals;
